/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Not_Found_BrandInputs */

const en_meta_not_found_brand = /** @type {(inputs: Meta_Not_Found_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`404 Page Not Found | Shoot Share Connect`)
};

const es_meta_not_found_brand = /** @type {(inputs: Meta_Not_Found_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`404 — Página no encontrada | Shoot Share Connect`)
};

const fr_meta_not_found_brand = /** @type {(inputs: Meta_Not_Found_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`404 — Page non trouvée | Shoot Share Connect`)
};

const de_meta_not_found_brand = /** @type {(inputs: Meta_Not_Found_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`404 — Seite nicht gefunden | Shoot Share Connect`)
};

const ja_meta_not_found_brand = /** @type {(inputs: Meta_Not_Found_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`404 — ページが見つかりません | Shoot Share Connect`)
};

const zh_meta_not_found_brand = /** @type {(inputs: Meta_Not_Found_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`404 — 页面未找到 | Shoot Share Connect`)
};

const ar_meta_not_found_brand = /** @type {(inputs: Meta_Not_Found_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`404 — الصفحة غير موجودة | Shoot Share Connect`)
};

const id_meta_not_found_brand = /** @type {(inputs: Meta_Not_Found_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`404 — Halaman Tidak Ditemukan | Shoot Share Connect`)
};

const it_meta_not_found_brand = /** @type {(inputs: Meta_Not_Found_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`404 — Pagina Non Trovata | Shoot Share Connect`)
};

const ru_meta_not_found_brand = /** @type {(inputs: Meta_Not_Found_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`404 — Страница не найдена | Shoot Share Connect`)
};

const pt_meta_not_found_brand = /** @type {(inputs: Meta_Not_Found_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`404 — Página Não Encontrada | Shoot Share Connect`)
};

const ko_meta_not_found_brand = /** @type {(inputs: Meta_Not_Found_BrandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`404 — 페이지를 찾을 수 없습니다 | Shoot Share Connect`)
};

/**
* | output |
* | --- |
* | "404 Page Not Found \| Shoot Share Connect" |
*
* @param {Meta_Not_Found_BrandInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const meta_not_found_brand = /** @type {((inputs?: Meta_Not_Found_BrandInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Not_Found_BrandInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_meta_not_found_brand(inputs)
	if (locale === "es") return es_meta_not_found_brand(inputs)
	if (locale === "fr") return fr_meta_not_found_brand(inputs)
	if (locale === "de") return de_meta_not_found_brand(inputs)
	if (locale === "ja") return ja_meta_not_found_brand(inputs)
	if (locale === "zh") return zh_meta_not_found_brand(inputs)
	if (locale === "ar") return ar_meta_not_found_brand(inputs)
	if (locale === "id") return id_meta_not_found_brand(inputs)
	if (locale === "it") return it_meta_not_found_brand(inputs)
	if (locale === "ru") return ru_meta_not_found_brand(inputs)
	if (locale === "pt") return pt_meta_not_found_brand(inputs)
	return ko_meta_not_found_brand(inputs)
});